(function () {
	'use strict';
	angular
		.module('rms.common')
		.directive('placementTab', placementTab);

	function placementTab(lodash) {
		return {
			restrict: 'E',
			templateUrl: 'rms/templates/shared/placement-tab',
			link: function(scope) {
				var vm = scope.vm;
				var placement_datasource = {};

				scope.component_data = {
					isActive: isActive,
					current_view: getCurrentView(),
					setView: setView,
					placement_datasource: placement_datasource
				};



				function getCurrentView() {
					if (lodash.has(scope.vm.panelState.structure, 'options.default_view')) {
						return scope.vm.panelState.structure.options.default_view;
					}
					return (vm.panelState.structure.options.has_details) ? 'details' : 'history';
				}

				function setView(view) {
					scope.component_data.current_view = view;
				}

				function isActive(type) {
					return type == scope.component_data.current_view;
				}
			}
		};
	}

})();